module.exports = __webpack_public_path__ + "a0f15ddf474b4759d67b05d35bd15efb.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-slogan-1.png
// module id = 501
// module chunks = 0